module.exports = __webpack_public_path__ + "static/media/quizBadgeLevel3Locked.4daf2abe.png";